namespace $.$$ {

	export class $shm_list_head extends $.$shm_list_head {

		head_rows() {
			const controls = this.Controls().sub()
			return [
				this.Head(),
				...( controls?.some( item => item != null && item !== false ) ? [ this.Controls() ] : [] ),
			]
		}

		@ $mol_mem
		sort_by( next?: string ): string {
			return this.$.$mol_state_local.value( this + '.sort_by', next ) ?? super.sort_by()
		}

		@ $mol_mem
		sort_order( next?: string ): string {
			// hardcoded on purpose
			if( this.sort_by() == 'title' ) return 'asc'
			return 'desc'
			return this.$.$mol_state_local.value( this + '.sort_order', next ) ?? super.sort_order()
		}

		settings_content() {
			return [
				...( this.group_content().length ? [ this.Group_label() ] : [] ),
				...( this.sort_content().length ? [ this.Sort_label() ] : [] ),
				...( this.filter_content().length ? [ this.Filter_label() ] : [] ),
			]
		}

	}

}
